export const valueMotivoProblemas = '14';
export const valueMotivoOtros = '13';

export const CTAsMotivoRenovador = [
	{
		label: 'Los plazos de entrega',
		value: '1',
	},
	{
		label: 'El precio y las opciones de financiación',
		value: '2',
	},
	{
		label: 'El diseño del coche',
		value: '3',
	},
	{
		label: 'El equipamiento del coche',
		value: '4',
	},
	{
		label: 'Relación calidad/precio',
		value: '5',
	},
	{
		label: 'La poca variedad de modelos y tecnologías disponibles',
		value: '6',
	},
	{
		label: 'Mi experiencia con el concesionario de venta',
		value: '7',
	},
	{
		label: 'Por problemas con mi vehículo anterior',
		value: valueMotivoProblemas
	},
	{
		label: 'Otros motivos',
		value: valueMotivoOtros
	},
];

export const CTAsMotivoRenovadorProblemas = [
	{
		label: 'El consumo de combustible del vehículo anterior',
		value: '8',
	},
	{
		label: 'Los costes de mantenimiento del vehículo anterior',
		value: '9',
	},
	{
		label: 'Las averías sufridas con el vehículo anterior',
		value: '10',
	},
	{
		label: 'Mi experiencia previa con el servicio de posventa',
		value: '11',
	},
	{
		label: 'Otras experiencias con la marca',
		value: '12',
	},
];
